import { render, staticRenderFns } from "./CatapultBanner.vue?vue&type=template&id=5dca05dc&scoped=true"
import script from "./CatapultBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatapultBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CatapultBanner.vue?vue&type=style&index=0&id=5dca05dc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dca05dc",
  null
  
)

export default component.exports